const roles = {
  ADMIN: 'admin',
  CREATE_API_KEY: 'createApiKey',
  STORE_STATISTICS: 'storeStatistics',
  CREATE_PRODUCT_VERSION: 'createProductVersion',
  VIEW_DASHBOARD_STATISTICS: 'viewDashboardStatistics',
};

module.exports = roles;
